import './loading.css'

function Loading() {
  return (
    <div className="flex items-center justify-center">
      <div className="loader" />
    </div>
  )
}

export default Loading
